import { render, staticRenderFns } from "./OpsPatientCard.vue?vue&type=template&id=40b9a380&scoped=true"
import script from "./OpsPatientCard.vue?vue&type=script&lang=js"
export * from "./OpsPatientCard.vue?vue&type=script&lang=js"
import style0 from "./OpsPatientCard.vue?vue&type=style&index=0&id=40b9a380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9a380",
  null
  
)

export default component.exports